
export enum HandleTypeEnum {
    TWITTER = 'TWITTER',
    INSTAGRAM = 'INSTAGRAM',
    FACEBOOK = 'FACEBOOK',
    WEBSITE = 'WEBSITE',
    EMAIL = 'EMAIL',
    LINKEDIN = 'LINKEDIN',
    PHONE = 'PHONE',
    BLUESKY = 'BLUESKY',
    TIKTOK = 'TIKTOK',
    YOUTUBE = 'YOUTUBE'
}


export const handleIconMap: Record<HandleTypeEnum, string> = {
    [HandleTypeEnum.EMAIL]:     'fa-solid fa-envelope',
    [HandleTypeEnum.WEBSITE]:   'fa-solid fa-earth-americas',
    [HandleTypeEnum.PHONE]:     'fa-solid fa-phone',
    [HandleTypeEnum.TWITTER]:   'fa-brands fa-x-twitter',
    [HandleTypeEnum.INSTAGRAM]: 'fa-brands fa-instagram',
    [HandleTypeEnum.FACEBOOK]:  'fa-brands fa-facebook',
    [HandleTypeEnum.LINKEDIN]:  'fa-brands fa-linkedin',
    [HandleTypeEnum.YOUTUBE]:   'fa-brands fa-youtube',
    [HandleTypeEnum.TIKTOK]:    'fa-brands fa-tiktok',
    [HandleTypeEnum.BLUESKY]:   'fa-brands fa-bluesky',
};


export const handleTypeDisplayOrder = [
    HandleTypeEnum.WEBSITE,
    HandleTypeEnum.EMAIL,
    HandleTypeEnum.PHONE,
    HandleTypeEnum.TWITTER,
    HandleTypeEnum.INSTAGRAM,
    HandleTypeEnum.FACEBOOK,
    HandleTypeEnum.LINKEDIN,
    HandleTypeEnum.YOUTUBE,
    HandleTypeEnum.TIKTOK,
    HandleTypeEnum.BLUESKY
];

export const handleTypeCompare = (a: {type: HandleTypeEnum}, b: {type: HandleTypeEnum}) => {
    const aSortPosition = handleTypeDisplayOrder.indexOf(a.type);
    const bSortPosition = handleTypeDisplayOrder.indexOf(b.type);

    if (aSortPosition < bSortPosition) {
        return -1;
    }

    if (aSortPosition > bSortPosition) {
        return 1;
    }

    return 0;
};
